import React, {useEffect, useState} from 'react';
import MetaTags from 'react-meta-tags';  // Added Meta Tag npm Package
import { Container, CardBody, CardTitle, Table, Row, Col, Card, UncontrolledTooltip, Badge, Button, Input, Alert, Modal, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import { Link } from 'react-router-dom';
import Breadcrumbs from "../../components/Common/Breadcrumb";
import * as url from "../../helpers/url_helper"
import axios from 'axios';
import { formatDate, HRConfig, TOAST_OPTIONS } from './../../helpers/backend_helper';

import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";
import Swal from 'sweetalert2';
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';

import toastr, { options } from "toastr";
import "toastr/build/toastr.min.css";

import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import PropTypes from "prop-types";
import {useHistory } from 'react-router-dom';
import {TIMESHEETS, PAYROLLEXPALLOCATIONS} from '../../helpers/url_helper';

const ApprovedTimesheets = () => {
  const history = useHistory()
  const [pList, setPList] = useState([])
  const [modal, setmodal] = useState(false);
  const [modal_item, setmodal_item] = useState(false);
  const [isLoading, setIsLoading] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [empNo, setEmpNo] = useState('')
  const [empName, setEmpName] = useState('')
  const [weekStartDate, setweekStartDate] = useState('')
  const [weekEndDate, setweekEndDate] = useState('')
  const [year, setyear] = useState('')
  const [month, setmonth] = useState('')
  const [employeeNo, setemployeeNo] = useState('')
  const [employeeName, setemployeeName] = useState('')
  const [description, setdescription] = useState('')
  const [hours, sethours] = useState('')
  const [workingDay, setworkingDay] = useState('')
  const [leaveType, setleaveType] = useState('')
  const [fundsource, setFundSource] = useState('')
  const [dimensionValueCode1, setdimensionValueCode1] = useState('')
  const [dimensionValueCode2, setdimensionValueCode2] = useState('')
  const [status, setstatus] = useState('')
  const [comment, setcomment] = useState('')
  const [CompanyID, setCompanyID] = useState('')
  const [timesheetlines, setTimesheetlines] = useState([])
  const [causesofAbsence, setCausesofAbsence] = useState([])
  const [payrollexpallocation, setPayrollExpAllocation] = useState([])
  const [lineSystemID, setLineSystemId] = useState('')
  const [basicpayED, setBasicPayED] = useState('')
  const [selectedNo, setSelectedNo]= useState('')
  const [noo, setNoo] = useState([])
  const [periodrange, setPeriodRange] = useState('')
  const [empTitle, setEmpTitle] = useState('')

  toastr.options = TOAST_OPTIONS;

  const removeBodyCss = () => {
    document.body.classList.add("no_padding");
  }
  const tog_case = () => {
    setmodal(!modal);
    removeBodyCss();
  }

  const [rows1, setrows1] = useState([{ id: 1 }]);

  const [formRows, setFormRows] = useState([{ id: 1 }]);

  const onAddFormRow = () => {
    const modifiedRows = [...formRows];
    modifiedRows.push({ id: modifiedRows.length + 1 });
    setFormRows(modifiedRows);
  };

  const onDeleteFormRow = id => {
    if (id !== 1) {
    var modifiedRows = [...formRows];
    modifiedRows = modifiedRows.filter(x => x["id"] !== id);
    setFormRows(modifiedRows);
    }
  };
  const handleClickDetails = (t) =>{
    setDetails(t)
    console.log(t)
    tog_details();
  }
  const tog_item = () => {
    setmodal_item(!modal_item);
    removeBodyCss();
  }

  const handlechangeFundSource = (e) => {
    setdimensionValueCode1(e.value)  
    console.log(e.value)         
  }
    
  const clearLineData = () =>{
    setweekStartDate('')
    setweekEndDate('')
    setyear('')
    setmonth('')
    setdescription('')
    sethours('')
    setworkingDay('')
    setleaveType('')
    setdimensionValueCode1('')
    setdimensionValueCode2('')
    setstatus('')
    setcomment('')
    setLineSystemId('')
  }

  const getFundSource = async() => {
    // axios.get(url.PAYROLLSETUP +"?company="+ obj.activeCompany, HRConfig)
    //     .then((r)=>{ 
    //       setBasicPayED(r.data.value[0].basicPayEDCode);
    //       let lvBasicPayED = r.data.value[0].basicPayEDCode;
          
          axios.get(PAYROLLEXPALLOCATIONS+"?$filter=employeeNo eq '"+empNo+"' and contains(edCode, 'BASIC') &company="+ CompanyID, HRConfig)
          .then((r)=>{ 
            let options = []
                r.data.value.map((e)=>{   
                  //options.push({label: `${e.FSDescription}  ${e.workPlan} ${e.edCode} ${e.allocated}`,value: `${e.dimensionValueCode2}#${e.workPlan}`})
                  //options.push({label: `${e.FSDescription}`,value: `${e.dimensionValueCode2}`})
                  options.push({label: `${e.dimensionValueCode2}`,value: e.dimensionValueCode2})
                })

            let uniqueOptions = r.data.value.map(e => e.dimensionValueCode2)
                .filter(
                  (value, index, currentValue) => currentValue.indexOf(value) === index
                );

                console.log(options);

            setPayrollExpAllocation(options);
            setNoo(options)
        }).catch((e)=>{
            console.log(e) 
        })

}

  const handleEditLine = (p) =>{
    setIsEdit(true)
    getFundSource()
    tog_item()
    setweekStartDate(p.weekStartDate)
    setweekEndDate(p.weekEndDate)
    setyear(p.year)
    setmonth(p.month)
    setdescription(p.description)
    sethours(p.hours)
    setworkingDay(p.workingDay)
    setleaveType(p.leaveType)
    setSelectedNo([{label: p.dimensionValueCode1, value: dimensionValueCode1}])
    setdimensionValueCode1(p.dimensionValueCode1)
    setdimensionValueCode2(p.dimensionValueCode2)
    setstatus(p.status)
    setcomment(p.comment)
    setLineSystemId(p.SystemId)
    setFundSource(p.dimensionValueCode1)
    console.log(p.dimensionValueCode1)
    console.log(p)
  }
  
const handleSendChange = (e) =>{
 // setSelectedNo([{label: e.label , value: (e.value).split("#")[0]}])
  //setSelectedNo(e)
  setSelectedNo(e)
  setFundSource(e.value)
  console.log(e.value)
}
  const getData = () =>{
    setIsLoading(true)
    if (localStorage.getItem("authMildUser")) {
      const obj = JSON.parse(localStorage.getItem("authMildUser"));
      setEmpNo(obj.uid)
      setEmpName(obj.username)
      setCompanyID(obj.activeCompany);
      let EmployeeNo = obj.uid;

      axios.get(url.PAYROLLSETUP +"?company="+ obj.activeCompany, HRConfig)
        .then((r)=>{ 
          setBasicPayED(r.data.value[0].basicPayEDCode);
          let lvBasicPayED = r.data.value[0].basicPayEDCode;

          
          axios.get(PAYROLLEXPALLOCATIONS+"?$filter=employeeNo eq '"+EmployeeNo+"' and contains(edCode, 'BASIC') &company="+ obj.activeCompany, HRConfig)
          .then((r)=>{ 
            let options = []
                // r.data.value.map((e)=>{   
                //     payrollexpallocation.push({label: `${e.FSDescription}  ${e.workPlan} ${e.edCode} ${e.allocated}`,value: e.dimensionValueCode2})
                // })
            //setPayrollExpAllocation(options);
        }).catch((e)=>{
            console.log(e) 
        })
        }).catch((e)=>{
          console.log(e) 
        })

        axios.get(`${url.EMPLOYEES2}?$filter=No eq '${EmployeeNo}'&company=${obj.activeCompany}`, HRConfig).then((r)=>{
          setEmpTitle(r.data.value[0].JobTitle);  
          setPeriodRange(r.data.value[0].timesheetsperiodrange);                 
          }).catch((e)=>{ 
              console.log(e); 
              setIsLoading(false) 
      })

      axios.get(TIMESHEETS+"?$filter=employeeNo eq '"+EmployeeNo+"'and status eq 'Approved'&company="+ obj.activeCompany, HRConfig)
        .then((r)=>{ 
          setIsLoading(false)
          setPList(r.data.value)
          setTimesheetlines(r.data.value)

        axios.get(url.CAUSES_OF_ABSENCE +"?company="+ obj.activeCompany, HRConfig)
          .then((r)=>{ 
            setCausesofAbsence(r.data.value);
        }).catch((e)=>{
            console.log(e) 
        })

      }).catch((e)=>{ 
        console.log(e); setIsLoading(false); 
      })
    }

  }
  useEffect(()=>{
      getData()
  },[])
        const { SearchBar } = Search;
        const columns = [
          {
            dataField: "action",
            isDummyField: true,
            text: 'Action',
            formatter: actionFormatter
          },
          {
            dataField: 'entryNo',
            text: 'Entry No.',
            sort: true
          },
          {
            dataField: 'year',
            text: 'Year',
            sort: true
          },
          {
            dataField: 'month', 
            text: 'Month',
            sort: true
          }, 
          {
            dataField: 'employeeName',
            text: 'Employee Name',
            sort: true
          },             
          {
            dataField: 'weekStartDate',
            text: 'Week Start date',
            sort: true
          }, 
          {
            dataField: 'weekEndDate',
            text: 'Week End date',
            sort: true
          },             
          {
            dataField: 'hours',
            text: 'Hours',
            sort: true
          }, 
          {
            dataField: 'status',
            text: 'Status',
            sort: true,
            formatter: statusFormatter
          }
            ];
    
            const defaultSorted = [{
              dataField: 'no',
              order: 'desc'
            }];
      
            function planFormatter(cellContent,row){
              return(
                <span> <strong>{row.purchaseRequisitionLines.length}</strong></span>
              )
            }

            function actionFormatter(cellContent, row){
              return (
                <div className="d-flex gap-3">
                  <Link
                    to="#"
                    className="text-success"
                    onClick={()=>{handleEditLine(row)}}
                  >
                    <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
                    <UncontrolledTooltip placement="top" target="edittooltip">
                      View
                    </UncontrolledTooltip>
                  </Link>

                </div>
              ); 
          }

            function statusFormatter(cellContent, row) {
              if (row.status == "Open") {
                return (
                  <div>
                      <Badge className="me-2 bg-danger">
                      { cellContent }
                      </Badge>
                  </div>
                );
              }else if ((row.status == "Approved") || (row.status == "Released")){
                return (
                  <div>
                      <Badge className="me-2 bg-success">
                      { cellContent }
                      </Badge>
                  </div>
                );
              }else if (row.status == "Withdrawn(Cancelled)"){
                return (
                  <div>
                      <Badge className="me-2 bg-secondary">
                      { cellContent }
                      </Badge>
                  </div>
                );
              }else{
                return (
                  <div>
                      <Badge className="me-2 bg-warning">
                      { cellContent }
                      </Badge>
                  </div>
                );
              }
            }
        
        return (
            <>
                <div className="page-content">
                    <MetaTags>
                    <title>Timesheets | BRIDGE</title>
                    </MetaTags>
                    <Container fluid={true}>
                        <Breadcrumbs title="Human Resources Management" breadcrumbItem="Timesheets" />
                        <Row>
                        <Col lg={12}>
                                {isLoading ? (<Alert  color="danger" role="alert">Please wait...</Alert>) : null}
                            </Col>
                        <Col xl={12}>
                            <Card>
                                <CardBody>
                                {(pList.length > 0) && (<>
                                    <ToolkitProvider
                                        keyField="SystemId"
                                        data={ pList }
                                        columns={ columns }
                                        search
                                        >
                                        { toolkitProps => (
                                            <React.Fragment>
                                                <Row className='mb-5'>
                                                  <Col lg={12}>
                                                  <div  className="rounded bg-light d-grid gap-2">
                                           
                                                      <SearchBar {...toolkitProps.searchProps} className="form-control bg-transparent border-0 searchTm m-0" />
                                                 
                                                    </div>
                                                  </Col>
                                                </Row>
                                                <Row>
                                                <Col xl="12">
                                                    <div className="table-responsive">
                                                
                                                    <BootstrapTable 
                                                      keyField='SystemId' 
                                                      data={ pList } 
                                                      columns={ columns } 
                                                      striped
                                                      hover
                                                      condensed
                                                      bordered={ false }
                                                      noDataIndication="No Records" 
                                                      defaultSorted={ defaultSorted }
                                                      classes={ "table align-middle table-wrap table-check" }
                                                          {...toolkitProps.baseProps}
                                                    />
                                                </div>
                                                </Col>
                                                </Row>
                                                </React.Fragment>
                                                
                                        )
                                        }
                                    </ToolkitProvider>
                  

                              
                                </>)}
                                {(pList.length < 1) && (<>
                                  <Row className="d-flex justify-content-center">
                                    <Col lg={8} >
                                      <div className="text-center">
                                        <div className="mb-4">
                                          <i className="mdi mdi-calendar-clock text-warning display-4" />
                                        </div>
                                        <div>
                                          <h5>No Approved Timesheets found</h5>
                                        <p className="text-muted"></p>
                                        </div>
                                      </div>
                                    </Col>
                                  </Row>
                                </>)}

                                  
                                </CardBody>
                                <Modal isOpen={modal_item} toggle={() => { tog_item(); }}  size="xxl" centered  backdrop={'static'}  >
                                        <div className="modal-header">
                                            <h5 className="modal-title mt-0" id="myModalLabel">{isEdit?`View `:`Add ` }Timesheet Line</h5>
                                            <button type="button"  onClick={() => { setmodal_item(false) }}  className="close" data-dismiss="modal"aria-label="Close">
                                                <span aria-hidden="true">&times;</span>
                                            </button>
                                        </div>
                                        <div className="modal-body">
                                            <Row>
                                              <Col lg={6}>
                                                <label htmlFor="floatingSelectGrid">Week Start Date</label>
                                                    <div className="form-floating mb-3">
                                                        { <Flatpickr
                                                            className="form-control"
                                                            disabled = {true}
                                                            value={weekStartDate}
                                                            onChange={(e)=>setweekStartDate(formatDate(e))}
                                                            options={{
                                                                altInput: true,
                                                                altFormat: "F j, Y",
                                                                dateFormat: "Y-m-d",
                                                                disabled: true
                                                            }}
                                                        /> }
                                                    </div>
                                              </Col>
                                              <Col lg={6}>
                                                <label htmlFor="floatingSelectGrid">Week End Date</label>
                                                    <div className="form-floating mb-3">
                                                        { <Flatpickr
                                                            className="form-control"
                                                            disabled = {true}
                                                            value={weekEndDate}
                                                            onChange={(e)=>setweekEndDate(formatDate(e))}
                                                            options={{
                                                                altInput: true,
                                                                altFormat: "F j, Y",
                                                                dateFormat: "Y-m-d",
                                                                disabled: true
                                                            }}
                                                        /> }
                                                    </div>
                                              </Col>
                                              <Col lg={6}>
                                                <label htmlFor="floatingDepartInput">Working Day</label>
                                                    <div className="form-floating mb-3">
                                                        <select 
                                                          className="form-select" 
                                                          value={workingDay} 
                                                          disabled = {true}
                                                          onChange={(e) =>{setworkingDay(e.target.value)}  
                                                          }>
                                                        <option value=" ">Select</option>
                                                        <option value="Worked">Worked</option>
                                                        <option value="Leave Day">Leave Day</option></select>
                                                    </div>
                                                </Col>
                                                  <Col lg={6}>
                                                <label htmlFor="floatingSelectGrid">Hours</label>
                                                    <div className="form-floating mb-3">
                                                        <input  
                                                          type="number" 
                                                          className="form-control" 
                                                          value={hours}  
                                                          disabled = {true}
                                                          onChange={(e)=>{ sethours(e.target.value)}} 
                                                        />
                                                    </div>
                                                </Col>

                                                {((workingDay == 'Worked') && (
                                                <Col lg={12}>
                                                  <label htmlFor="floatingSelectGrid">Fund Source</label>
                                                      <div className="form-floating mb-3">
                                                         <Select 
                                                          options={payrollexpallocation} 
                                                          classNamePrefix="select" 
                                                          isClearable={false} 
                                                          isSearchable={true}  
                                                          isDisabled = {true}
                                                          //value={dimensionValueCode1}
                                                          value={selectedNo}
                                                          //value={payrollexpallocation.find((option) => option.value === dimensionValueCode1)} 
                                                          onChange={handleSendChange}
                                                        />                                                         
                                                      </div>                                             
                                                </Col>
                                                ))}
                                                
                                                <Col lg={12}>
                                                    <label htmlFor="floatingSelectGrid">Description</label>
                                                        <div className="form-floating mb-3">
                                                            <input  
                                                              type="text" 
                                                              className="form-control" 
                                                              value={description} 
                                                              disabled = {true}
                                                              onChange={(e)=>setdescription(e.target.value)}   
                                                            />
                                                        </div>
                                                </Col>
                                                <Col lg={12}>
                                                    <label htmlFor="floatingSelectGrid">Comment</label>
                                                        <div className="form-floating mb-3">
                                                            <input  
                                                              type="text" 
                                                              className="form-control" 
                                                              value={comment} 
                                                              disabled = {true}
                                                              onChange={(e)=>setcomment(e.target.value)}   
                                                            />
                                                        </div>
                                                </Col>

                                                {((workingDay == 'Leave Day') && (
                                                <Col lg={6}>
                                                  <label htmlFor="floatingSelectGrid">Leave Type</label>
                                                      <div className="form-floating mb-3">
                                                        { <select className="form-select" 
                                                          value={leaveType} 
                                                          disabled = {true}
                                                          onChange={(e)=>setleaveType(e.target.value)}
                                                          > 
                                                          <option value=''>Select</option>
                                                              { causesofAbsence.map((l,k)=>( <option key={k} 
                                                                  value={l.Code}>{l.Description}
                                                          </option> ))}
                                                        </select> }
                                                      </div>                                             
                                                </Col>
                                                ))}

                                                <Col lg={6}>
                                                  <label htmlFor="floatingSelectGrid">Department</label>
                                                      <div className="form-floating mb-3">
                                                            <input  type="text" className="form-control" disabled = {true} value={dimensionValueCode2} onChange={(e)=>setdimensionValueCode2(e.target.value)}   />
                                                        </div>                                          
                                                </Col>
                                            </Row>
                                        </div>
                                        
                                        <div className="modal-footer justify-content-center">
                                            {(status =='Open') && (isEdit) && (isLoading ? 
                                                (<button type="button" className="btn btn-secondary" disabled={true}>Please wait...</button>)
                                                : ( <button type="button" className="btn btn-primary" onClick={()=>handleUpdateLine2()}>
                                                 <i className="mdi mdi-pencil" id="edittooltip" />{" "}Update line details...</button> ))
                                            }
                                            {!isEdit && (isLoading ? 
                                                (<button type="button" className="btn btn-secondary" disabled={true}>Please wait...</button>)
                                                : ( <button type="button" className="btn btn-success" onClick={()=>handleAddLine2()}>Save line details...</button> ))
                                            }
                                        </div>
                                </Modal>
                            </Card>
                            </Col>
                        </Row>
                           

                    </Container>
                </div>
            </>
        );
    }

export default ApprovedTimesheets;